import script from "./lead_form.vue?vue&type=script&setup=true&lang=js"
export * from "./lead_form.vue?vue&type=script&setup=true&lang=js"

import "./lead_form.vue?vue&type=style&index=0&id=49772952&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49772952"]])

export default __exports__